<template>
  <div class="cont">
    <div class="search">
        <input type="text" v-model="num" placeholder="请输入车牌号" />
        <div @click="search">搜索</div>
    </div>
    <el-amap class="amap-box" :vid="'amap-vue'"></el-amap>
  </div>
</template>

<script>
export default {
  data(){
    return {
      num:''
    }
  },
  methods:{
    search(){
      if(this.num == ''){
        this.$alert('请输入车牌号查询！', '温馨提示', {
          type:'warning',
          confirmButtonText: '确定'
        })
      }else{
        this.$alert('很抱歉，暂时没有定位到轨迹！', '温馨提示', {
          type:'warning',
          confirmButtonText: '确定'
        })
      }
      
    }
  },
  mounted(){
    this.$nextTick(() => {
      this.initMap()
    })
  }
}
</script>

<style lang="stylus" scoped>
  .cont
    position relative
    width: 100%
    height: 600px
    margin: 0 auto
    .search
      position: absolute
      width: 200px
      height: 75px
      top:0
      left: 50%
      margin-left: -100px
      padding: 30px
      background: #dde9ed
      z-index: 99
      input
        box-sizing: border-box
        border: none
        background: #fff
        width: 100%
        height: 32px
        line-height: 32px
        font-size: 16px
      div
        box-sizing: border-box
        width: 100%
        height: 32px
        margin-top: 15px
        line-height: 32px
        text-align: center
        background: #80c0d3
        color: #fff
        cursor: pointer
</style>